import React, { Component } from "react";
import { observer } from "mobx-react";

import { teleopJoystickPositions } from "@formant/core/model/teleopJoystickPositions";

import { SelectField } from "../common/SelectField";
import { Switch } from "../common/Switch";
import { JoystickAxisConfigurationFake } from "./JoystickAxisConfigurationFake";
import * as styles from "./JoystickConfigurationRow.scss";

export interface IJoystickConfigurationRowFakeProps {
    onAdd: () => void;
    position: "left" | "right";
}

@observer
export class JoystickConfigurationRowFake extends Component<IJoystickConfigurationRowFakeProps> {
    public render() {
        const { position } = this.props;
        const xAxis = <JoystickAxisConfigurationFake />;

        const yAxis = <JoystickAxisConfigurationFake />;

        return (
            <div className={styles["joystick-configuration-row"]}>
                <div className={styles.header}>
                    <span className={styles.text}>Position</span>
                    <SelectField
                        className={styles.position}
                        small={true}
                        disabled={true}
                        value={position}
                    >
                        {teleopJoystickPositions.map(_ => (
                            <option key={_} value={_}>
                                {_}
                            </option>
                        ))}
                    </SelectField>
                    <Switch
                        data-testid="joystick-switch-false"
                        onChange={this.onAdd}
                        state={false}
                    />
                </div>
                {xAxis}
                {yAxis}
            </div>
        );
    }

    private onAdd = () => {
        const { onAdd } = this.props;
        onAdd();
    };
}
